module.exports = __webpack_public_path__ + "img/circle.d759167b.png";